import styles from "./Dashboard.module.scss";
import { Info } from "../../components/Info";
import { Button } from "../../components/common/Button";
import { DashboardNav } from "../../components/DashboardNav";
import { Link } from "react-router-dom";
import { ModeContext } from "../../context/ModeContext";
import { useContext, useState } from "react";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
// import { useQuery } from '@apollo/client';
// import { ORGANISATION_COUNT, TAG_SUGGESTIONS } from '../../apollo/queries';

export const Dashboard = () => {
  const { adminMode } = useContext(ModeContext);
  // const [count, setCount] = useState(null)

    // useQuery(ORGANISATION_COUNT, {
    //     variables: {
    //         organisationType: "STARTUP"
    //     },
    //     onCompleted: (someData) => {
    //         console.log({someData})
    //         setCount(someData.count)
    //     },
    //     fetchPolicy: "no-cache"
    // });

  return (
    <div className={styles.wrapper}>
      {/*<GreetingsHeader title="<me.name>" subtitle={`Aantal startups ${count}`}/>*/}
        <GreetingsHeader title="<me.name>" subtitle={"Aantal startups"}/>

      <section className={styles.infoContainer}>
        <Info
          title="DASHBOARD - READINESS PROGRAMS"
          description="Welkom op de beginpagina van het Dashboard. Ga door naar de pagina: Programma’s om trainingen te plannen en te organiseren of bekijk de aanmeld status van de startups en begeleiders via onze anmeldingspagina.
          Heb je hulp nodig? Neem contact met ons op via de Helpdesk."
          element={
            <Link to="/programs">
              <Button className="primaryDark">
                {adminMode ? "Plan programma" : "Startups uitnodigen"}
              </Button>
            </Link>
          }
        />
      </section>
      <section className={styles.navigate}>
        <DashboardNav
          image="/assets/dashboard1.png"
          text={
            adminMode
              ? "Plan een programma in en communiceer het naar begeleiders en startups."
              : "Ontdek waar het programma over gaat en bekijk welke programma’s beschikbaar zijn om te communiceren naar jouw startups."
          }
          element={
            <Link to="/programs">
              <Button className="simple">
                {adminMode ? "Plan programma" : "Programma’s"}
              </Button>
            </Link>
          }
        />
        <DashboardNav
          image="/assets/dashboard2.png"
          text={
            adminMode
              ? "Bekijk welke begeleiders per programma deelnemen en nodig extra personen uit. Ook vindt je hier een overizcht van alle bevestigde startups die zullen deelenemen."
              : "Bekijk alle startups per programma en houd de status van jouw eigen uitgenodigde startups per programma bij."
          }
          element={
            <Link to={adminMode ? "/registration" : "/startups"}>
              <Button className="simple">
                {adminMode ? "Aanmeldingen" : "Startups"}
              </Button>
            </Link>
          }
        />
        <DashboardNav
          image="/assets/dashboard3.png"
          text={
            adminMode
              ? "Vragen? Geen probleem. Kom via onze helpdesk alles te weten over het Dashboard of plan via onze contact mogelijkheden persoonlijk hulp in."
              : "Vragen? Geen probleem. Kom via onze helpdesk alles te weten over het Startup Dashboard of plan via onze contact mogelijkheden persoonlijk hulp in."
          }
          element={<Button className="simple">Helpdesk</Button>}
        />
      </section>
    </div>
  );
};
